export default "__VITE_ASSET__0XUbz1iV__"